import { render, staticRenderFns } from "./ConfigHotel.vue?vue&type=template&id=385345ed&"
import script from "./ConfigHotel.vue?vue&type=script&lang=js&"
export * from "./ConfigHotel.vue?vue&type=script&lang=js&"
import style0 from "./ConfigHotel.vue?vue&type=style&index=0&id=385345ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports